import { organizationApi } from "@/core/data/api";

export default async (values) => {
  return await organizationApi.createOrganization(values);
};
